<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="listItems"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalRecords"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [5, 10, 20, 50]
            }"
        >
            <template v-slot:[`item.isActive`]="{ item }">
                <v-chip
                    :color="getColor(item.isActive)"
                    pill
                    dark
                    small
                    class="status-column"
                >
                    {{ getTextState(item.isActive) }}
                </v-chip>
            </template>
            <template v-slot:[`item.creationDateTime`]="{ item }">
                <span>
                    {{item.creationDateTime | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:[`item.endDate`]="{ item }">
                <span>
                    {{item.endDate | formatOnlyDate }}
                </span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom v-if="roleId == 1">
                    <template v-slot:activator="{ on, attrs }">
                        <span style="cursor: pointer;" class="circle mr-2 p-0" @click="onConfigClicked(item, 'edit')" v-bind="attrs" v-on="on">
                            <img src="/images/_SVGs/bo/edit_pencil.svg" alt="editar" onload="SVGInject(this)" width="20" height="20" />
                        </span>
                    </template>
                    <span>{{ $t('backoffice.actions.edit') }}</span>
                </v-tooltip>
            </template>
            <template v-slot:[`footer.prepend`]>
                <v-chip class="ml-8">
                    <span class="span-title-footer" >{{$t('backoffice.modules-management.vrm.components.datatable-reserve-pack.actual-balance')}}</span> <span class="span2-title-footer">{{ balance }}</span>
                </v-chip>
            </template>
        </v-data-table>

        <v-col class="mt-1" v-if="roleId == 1">
            <v-btn fab dark x-small color="var(--v-primary-base)" @click="$emit('add-pack-reserve')">
                <v-icon dark>
                    mdi-plus
                </v-icon>
            </v-btn>
            <span @click="$emit('add-pack-reserve')" class="ml-3 span-packs">{{$t('backoffice.modules-management.parts-information.datatable-reserve-pack.create-reserve-pack')}}</span>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listItems: null,
        totalRecords: Number,
        balance: Number,
        roleId: Number,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.invoice'),
                    value: "invoiceNumber",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.obs'),
                    value: "observations",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.qty'),
                    align: "start",
                    value: "chargedBalance",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.current-balance'),
                    value: "currentBalance",
                    align: "start",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.status'),
                    value: "isActive",
                    align: "center",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.create-date'),
                    value: "creationDateTime",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: this.$t('backoffice.modules-management.parts-information.datatable-reserve-pack.headers.end-date'),
                    value: "endDate",
                    sortable: false,
                    class: "header-table-color"
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color"
                }
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10
            },
        };
    },
    watch: {
      "options.page": {
        handler() {
          this.$emit('alterTableDatatableReservePack', this.options);
        },
      },
      "options.itemsPerPage": {
        handler() {
          this.$emit('alterTableDatatableReservePack', this.options);
        },
      },
    },
    computed: {
        checkRoleIdByLoggedInUser() {
            return this.$store.getters['auth/getState'].roleId;
        }
    },
    methods: {
        getColor(isActive) {
            if (isActive == true) return "green";
            else if (isActive == false) return "red";
            else return "orange";
        },
        getTextState(status){
            if (status == true) return this.$t('backoffice.general.active-status');
            else if (status == false) return this.$t('backoffice.general.inactive-status');
            else return this.$t('backoffice.modules-management.vrm.components.datatable-list.no-status')
        },
        onConfigClicked(item) {
            this.$emit('edit-pack-reserve', item);
        }
    }
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#content-backoffice {
    table {
        thead {
            tr {
                th {
                    border: 0;

                    &.header-table-color {
                        background-color: #f2f2f2 !important;
                        color: #9e9d9d !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 12px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }

    .span-packs {
        color: var(--v-primary-base);
        cursor: pointer;
    }
}
</style>
